import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "utils/api";
import { getAxiosErrorMessage } from "utils/httpErrors";

const initialState = {
  bannedBlockedScriptList: [],
  bannedBlockedScriptLoading: false,
  bannedBlockedScriptsearchText: "",
};

export const getBannedBlockedScriptList = createAsyncThunk(
  "bannedBlockedScript/getList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/script/block-script");
      const body = response.data;
      // Confirmed API shape: { status: 200, message: '...', data: [...] }
      if (body?.status === 200) {
        const list = body.data;
        // data is a plain array — return it directly
        if (Array.isArray(list)) return list;
        // safety: handle paginated shape just in case
        if (Array.isArray(list?.records)) return list.records;
        return [];
      }
      return rejectWithValue(body);
    } catch (error) {
      if (error.response?.status === 401) {
        return rejectWithValue("Unauthorized");
      }
      return rejectWithValue(getAxiosErrorMessage(error, "Request failed"));
    }
  }
);

const bannedBlockedScriptSlice = createSlice({
  name: "bannedBlockedScript",
  initialState,
  reducers: {
    setBannedBlickedScriptSearchText: (state, action) => {
      state.bannedBlockedScriptsearchText = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannedBlockedScriptList.pending, (state) => {
        // ✅ Only set loading — do NOT clear the list here
        // Clearing causes a flash to empty while data is in flight
        state.bannedBlockedScriptLoading = true;
      })
      .addCase(getBannedBlockedScriptList.fulfilled, (state, action) => {
        // action.payload is guaranteed to be a plain array
        state.bannedBlockedScriptList    = action.payload;
        state.bannedBlockedScriptLoading = false;
      })
      .addCase(getBannedBlockedScriptList.rejected, (state) => {
        state.bannedBlockedScriptLoading = false;
        state.bannedBlockedScriptList    = [];
      });
  },
});

export const { setBannedBlickedScriptSearchText } = bannedBlockedScriptSlice.actions;
export default bannedBlockedScriptSlice.reducer;